export default __webpack_public_path__ + "static/gallery-award-oneearth-a92912ee55997a8e6228c5ba179aa7e8.jpg";